package com.essntl.features.service.data.supabase.service

import com.essntl.features.file.data.supabase.FileDto
import com.essntl.features.service.domain.model.service.ServiceModel
import io.github.jan.supabase.postgrest.query.Columns
import kotlinx.serialization.SerialName
import kotlinx.serialization.Serializable

@Serializable
data class ServiceDto(
    val id: String,
    val title: String,
    val category: String?,
    val description: String?,
    @SerialName("area_id")
    val areaId: String?,
    val headline: String?,
    val tags: List<String>?,
    val images: List<String>?,
    @SerialName("primary_image_data")
    val primaryImage: FileDto? = null,
    @SerialName("created_at")
    val createdAt: String,
    @SerialName("updated_at")
    val updatedAt: String?,
    @SerialName("reference_code")
    val referenceCode: String?,
    @SerialName("internal_notes")
    val internalNotes: String?,
    @SerialName("qb_item_id")
    val qbItemId: String? = null,
    @SerialName("has_dynamic_price")
    val hasDynamicPrice: Boolean?,
) {
    fun toModel() =
        ServiceModel(
            id = id,
            title = title,
            category = category,
            description = description,
            areaId = areaId,
            headline = headline,
            tags = tags?.toSet(),
            images = images?.toSet(),
            primaryImage = primaryImage?.toModel(),
            createdAt = createdAt,
            updatedAt = updatedAt,
            referenceCode = referenceCode,
            internalNotes = internalNotes,
            qbItemId = qbItemId,
            hasDynamicPrice = hasDynamicPrice ?: false,
        )

    companion object {
        const val COLUMNS_VALUE = "*, primary_image_data:primary_image(*)"
        fun getColumns() = Columns.raw(COLUMNS_VALUE)
    }
}